module.exports = __webpack_public_path__ + "a63a0dc03587b72622f433504abc73e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/closeTag.png
// module id = 107
// module chunks = 0